export enum TranslateStatisticType {
  Day = 0,
  Week = 1,
  Month = 2,
  Year = 3,
}
